export type PfcSessionStatusDisplay = {
  text: string;
  icon: string;
  colorClass: string;
}

export class PassportForCareConstants {
  static readonly SESSION_STATUS_IN_PROGRESS = 0; // Numeric value (not used by API)
  static readonly SESSION_STATUS_IN_PROGRESS_STRING = 'InProgress'; // What API returns
  static readonly SESSION_STATUS_COMPLETED_SUCCESS_STRING = 'CompletedSuccess'; // What API returns
  static readonly SESSION_STATUS_FAILED_STRING = 'Failed'; // What API returns
  static readonly SESSION_STATUS_TIMED_OUT_STRING = 'TimedOut'; // What API returns
  static readonly SESSION_STATUS_CANCELLED_STRING = 'Cancelled'; // What API returns
  static readonly LOGO_URL: string = 'https://cdn.buttercms.com/bofvQevMSUqb54Qwrh0C';
  static readonly LOGO_SYMBOL_URL: string = 'https://cdn.buttercms.com/dQnr9RWbQXuBZRS24sGS';

  static readonly SESSION_STATUS_DISPLAY: Record<string, PfcSessionStatusDisplay> = {
    'InProgress':       { text: 'In progress',   icon: 'fa-rotate',           colorClass: 'text-yellow-500' },
    'CompletedSuccess': { text: 'Successful',    icon: 'fa-badge-check',      colorClass: 'text-green-600'  },
    'Failed':           { text: 'Failed',        icon: 'fa-circle-xmark',     colorClass: 'error'           },
    'TimedOut':         { text: 'Timed out',     icon: 'fa-hourglass-clock',  colorClass: 'error'           },
    'Cancelled':        { text: 'Cancelled',     icon: 'fa-octagon',          colorClass: 'text-blue-500'   },
  };
}
